import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";
import { Logo } from "./Logo";

export const NAV = [
  { label: "Home", to: "/", id: "home" },
  { label: "In-Home Care", to: "/in-home-care", id: "in-home-care" },
  { label: "Housing & Residential", to: "/housing", id: "housing" },
  { label: "Join Our Care Team", to: "/careers", id: "careers" },
  { label: "Partner With Us", to: "/partner-with-us", id: "partner" },
  { label: "About Us", to: "/about", id: "about" },
  { label: "Contact", to: "/contact", id: "contact" },
];

const linkClass = ({ isActive }) =>
  `relative text-sm font-medium py-2 transition-colors duration-200 ${isActive ? "text-[#1E3A2B]" : "text-[#5A6561] hover:text-[#1E3A2B]"} ${isActive ? "after:absolute after:left-0 after:right-0 after:-bottom-0.5 after:h-0.5 after:bg-[#C86D51] after:rounded-full" : ""}`;

const MobileNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="xl:hidden p-2 rounded-full border border-[#E5E0D8] bg-white" aria-label="Open menu" data-testid="mobile-menu-button">
          <Menu className="h-5 w-5 text-[#1E3A2B]" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="bg-[#FAF8F5] w-[85vw] max-w-sm" data-testid="mobile-menu">
        <SheetTitle className="sr-only">Site navigation</SheetTitle>
        <nav className="mt-10 flex flex-col gap-1" aria-label="Mobile">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${n.id}`}
              className={({ isActive }) => `px-3 py-3 rounded-lg text-base ${isActive ? "bg-white text-[#1E3A2B] font-semibold" : "text-[#1C2421]"}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/in-home-care#care-questionnaire" onClick={() => setOpen(false)} className="btn-pill btn-primary mt-6" data-testid="mobile-find-care-cta-button">Find Care</Link>
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export const Header = () => (
  <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FAF8F5]/90 border-b border-[#E5E0D8]">
    <div className="container-site flex items-center justify-between h-20 gap-6">
      <Link to="/" aria-label="Friendship Pen Care Services home" data-testid="header-logo-link"><Logo /></Link>
      <nav className="hidden xl:flex items-center gap-7" aria-label="Main">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end className={linkClass} data-testid={`nav-link-${n.id}`}>{n.label}</NavLink>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <Link to="/in-home-care#care-questionnaire" className="btn-pill btn-primary hidden sm:inline-flex !py-2.5" data-testid="header-find-care-cta-button">Find Care</Link>
        <MobileNav />
      </div>
    </div>
  </header>
);
